import BaseModel from "../../core/components/input-widget/BaseModel";
import i18n from "@/shared/i18n";

export default class LotProposalSearchModel extends BaseModel {
  lot_no = null;
  receipt_no = null;
  item_no = null;
  title = null;

  attributeLabels = {
    lot_no: i18n.t('Lot No'),
    receipt_no: i18n.t('Receipt No'),
    item_no: i18n.t('Item Number'),
    title: i18n.t('Title'),
  };

  attributePlaceholders = this.attributeLabels;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }
}
